import React from "react";
import { SiteHeader } from "../components/SiteHeader";
import { Hero } from "../components/Hero";
import { ConnectionSection } from "../components/ConnectionSection";
import { SolutionSection } from "../components/SolutionSection";
import { ContentsSection } from "../components/ContentsSection";
import { ActivityBookSection } from "../components/ActivityBookSection";
import { EmotionalSection } from "../components/EmotionalSection";
import { BonusSection } from "../components/BonusSection";
import { HowItWorksSection } from "../components/HowItWorksSection";
import { PersonaSection } from "../components/PersonaSection";
import { OfferSection } from "../components/OfferSection";
import { GuaranteeSection } from "../components/GuaranteeSection";
import { FaqSection } from "../components/FaqSection";
import { ClosingSection } from "../components/ClosingSection";
import { SiteFooter } from "../components/SiteFooter";
export function Landing() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-201" data-mp="m591z0tgkr16">
      <SiteHeader data-id="element-202" data-mp="2bboy9wr7zzy" />
      <main data-id="element-203" data-mp="27nu97fkp7jn">
        <Hero data-id="element-204" data-mp="3tgbgrqpjv0ss" />
        <ConnectionSection data-id="element-205" data-mp="3tftof560d6q5" />
        <SolutionSection data-id="element-206" data-mp="3tfjw3axhqnha" />
        <ContentsSection data-id="element-207" data-mp="3tifuf0d93e69" />
        <ActivityBookSection data-id="element-208" data-mp="3peq4a6gxgoj4" />
        <EmotionalSection data-id="element-209" data-mp="3pfrj8m12dv64" />
        <BonusSection data-id="element-210" data-mp="3pezzc8gtxlvo" />
        <HowItWorksSection data-id="element-211" data-mp="3pgkt3vvbl0sh" />
        <PersonaSection data-id="element-212" data-mp="3kg6j48a5rgrt" />
        <OfferSection data-id="element-213" data-mp="3kgyg9njelmk7" />
        <GuaranteeSection data-id="element-214" data-mp="3khhmi6zoymie" />
        <FaqSection data-id="element-215" data-mp="l0i981d74znv" />
        <ClosingSection data-id="element-216" data-mp="l11kx0c96rtg" />
      </main>
      <SiteFooter data-id="element-217" data-mp="l0038d0qf72r" />
    </div>;
}